import { BabylonjsModule } from '@modules/babylonjs';
import { BaseSystem, SystemOperationDefinition, Zed } from '@modules/core';

import { clearArchetype } from '../';

import type { CameraTargetResponse, Entity } from '../';
import type { World } from 'miniplex';

/**

import type { CameraTargetResponse } from '..';

/**
 * 설명 추가 필요
 * 
 * @group System
 * @category System
 */
export class CameraTargetSystem implements BaseSystem {
  static readonly INJECTABLE_TOKEN = Symbol.for('CameraTargetSystem');

  public getCameraTargets() {
    return this.getCameraTargetResponseByEntities(this.getCameraTargetEntities()) ?? [];
  }
  public getCameraTargetEntityWithSameName(targetName: string) {
    const entities = this.targetArchetype.entities.find((e) => e.TransformNode.name == targetName);
    return entities;
  }

  private targetArchetype;

  constructor({
    [Zed.WORLD_TOKEN]: world,
    [BabylonjsModule.INJECTABLE_TOKEN]: babylonjs,
  }: {
    [Zed.WORLD_TOKEN]: World<Entity>;
    [BabylonjsModule.INJECTABLE_TOKEN]: Pick<BabylonjsModule, 'scene'>;
  }) {
    this.targetArchetype = world.with('TransformNode', 'CameraTarget');
  }

  dispose() {
    clearArchetype(this.targetArchetype);
  }

  public getCameraTargetEntity(entityId: string) {
    return this.targetArchetype.entities.find((e) => e.entityId === entityId);
  }
  public getCameraTargetEntities() {
    return this.targetArchetype.entities ?? [];
  }

  private getCameraTargetResponseByEntities(entities: ReturnType<typeof this.getCameraTargetEntities>) {
    return entities.flatMap((e) => {
      return {
        entityId: e.entityId,
        name: e.TransformNode.name,
      } as CameraTargetResponse;
    });
  }

  operations = [];
}
